import i18n from '@/lang'

export function unavailabilityDatesProviderIdLabel(entity) {
   let scope, name;

    switch (entity.unavailabilities_provider_scope) {
      case 'corporation':
        name = entity.corporation.name
        scope = i18n.t("UserForm.scopes.corporation", { name })
        break;
      case 'entity':
        name = entity.name
        scope = i18n.t("UserForm.scopes.entity", { name })
        break;
      default:
      return
    }

    return i18n.t("UserForm.unavailability_dates_provider_id", { scope })
}



// WEBPACK FOOTER //
// ./src/helpers/entities.js